
import React from "react";
import "./skills.css";
import tick from "../../assets/tick.png";

import foodImg from "../../assets/food1.png";
import groceryImg from "../../assets/grocery1.png";
import taxiImg from "../../assets/taxi1.png";

const Skills = () => {
  return (
    <section id="skillssection">
      <h2 className="skillssectiontitle">Miogra Features</h2>

      <div className="skills-row">
        {/* 1️⃣ Food Delivery (Content Left | Image Right) */}
        <div className="skillbox-row">
          <div className="skill-content">
            <h3 className="skillboxtitle">Food Delivery — Deliciousness Delivered Fast</h3>
            <p className="elementsubtitle">
              Experience hassle-free dining with Miogra Food Delivery.<br />
              Discover nearby restaurants, explore cuisines from Indian to Italian, and enjoy your favorite meals in minutes.
            </p>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Browse top-rated restaurants & exclusive offers</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Filter by cuisine, ratings, or distance</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Track your delivery live on map</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Secure & quick in-app payment options</p>
            </div>
          </div>

          <div className="skill-image">
            <img src={foodImg} alt="food" />
          </div>
        </div>

        {/* 2️⃣ Grocery (Image Left | Content Right) */}
        <div className="skillbox-row reverse">
          <div className="skill-image">
            <img src={groceryImg} alt="grocery" />
          </div>

          <div className="skill-content">
            <h3 className="skillboxtitle">Grocery — Essentials at Your Doorstep</h3>
            <p className="elementsubtitle">
              Never run out of daily needs with Miogra Grocery Orders.<br />
              From fresh fruits to household items, get everything delivered fast & fresh.
            </p>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Choose from local grocery partners in your area</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Order daily essentials and fresh produce</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Express 30-minute delivery available</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Track orders and get instant updates</p>
            </div>
          </div>
        </div>

        {/* 3️⃣ Taxi Booking (Content Left | Image Right) */}
        <div className="skillbox-row">
          <div className="skill-content">
            <h3 className="skillboxtitle">Taxi Booking — Rides When You Need Them</h3>
            <p className="elementsubtitle">
              Your all-in-one app for quick, safe, and affordable rides.<br />
              Book a cab instantly and track your ride — all in real-time.
            </p>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Instant ride booking with nearby drivers</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">View driver & vehicle details</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Live ride tracking on maps</p>
            </div>

            <div className="skillelement">
              <img src={tick} className="skillelementimg" />
              <p className="elementtitle">Multiple payment options</p>
            </div>
          </div>

          <div className="skill-image">
            <img src={taxiImg} alt="taxi" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
